module.exports = __webpack_public_path__ + "static/media/android-3.85f88d6c.jpg";